import { render, staticRenderFns } from "./NgSelectElectronPrinters.vue?vue&type=template&id=8537d0cc"
import script from "./NgSelectElectronPrinters.vue?vue&type=script&lang=js"
export * from "./NgSelectElectronPrinters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports